<template>
	<div style="text-align: center">
		<van-image :src="smallLogo" style="width: 100vw;"/>
		<van-image :src="error" style="width: 60vw;"/>
	</div>
</template>

<script>

	import {Image} from 'vant';

	export default {
		name: 'Page500',
		components: {
			VanImage: Image
		},
		data() {
			return {
				smallLogo: require('@/assets/small-logo.png'),
				error: require('@/assets/500.png')
			}
		}
	}
</script>
